<template>
  <div class="newsMobile">
    <div class="newsItem backgroundWhite pb23">
      <div class="title">业界认可</div>
      <swiper :options="swiperOption">
        <swiper-slide class="swiperSlide" v-for="(item,index) in swiperList" :key="index">
          <img style="width: 3.09rem;height:2.96rem;" :src="item.url">
        </swiper-slide>
      </swiper>
    </div>
    <div class="newsItem backgroundGray">
      <div class="title">优加新闻</div>
      <div class="list">
        <div class="listItem" v-for="(item,index) in newsList" :key="index">
          <img class="itemImg" :src="item.imageUrl" alt="">
          <div class="con">
            <div>
              <div class="con_title">{{item.title}}</div>
              <div class="con_desc">{{item.content}}</div>
            </div>
            <div class="tar" @click="goDetail(item.url)">
              <span class="detailBtn">进入新闻</span>
              <img class="arrowRightIcon" src="../../assets/image/arrowRight.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentIndex" :page-sizes="[10, 20, 30, 50, 100]" :page-size="size" layout="total,pager "
        :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
   import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  let vm = null
  export default {
    props: ['newsList', 'totalCount', 'size', 'currentIndex','swiperList'],
    components: {
      swiper,
      swiperSlide,
    },
    data() {
      return {
        swiperCurrentIndex: 0,
        
        swiperOption: {
          autoplay: true, //是否自动播放 true 是  false 否
          slidesPerView: 3, //一排展示几个
          effect: 'coverflow', //轮播图的切换效果  coverflow 3D
          centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左。
          spaceBetween: '-30%', //每个轮播图之间设置距离（单位px）。
          loop: true, // 是否循环播放
          coverflowEffect: { //cover flow是类似于苹果将多首歌曲的封面以3D界面的形式显示出来的方式。coverflow效果参数，可选值：
            rotate: 0, //slide做3d旋转时Y轴的旋转角度
            stretch: 80, //每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
            depth: 100, //slide的位置深度。值越大z轴距离越远，看起来越小。
            modifier: 5, //depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显
            slideShadows: false //是否开启slide阴影
          },
          on: {
            slideChange(){
              vm.swiperCurrentIndex = this.activeIndex
              // console.log(this.activeIndex,'activeIndex',vm.swiperCurrentIndex)
            }
          }
        },
      }
    },
    created() {
      vm = this
    },
    methods: {
      handleSizeChange(size) {
        this.$emit('searchEmit', 'size', size)

      },
      handleCurrentChange(index) {
        this.$emit('searchEmit', 'index', index)
      },
      goDetail(url) {
        window.open(url, '_blank')
      }
    }

  }
</script>

<style lang="less" scoped>
  .backgroundGray {
    background: #F8F9FD;
  }

  .backgroundWhite {
    background: #FFFFFF;
  }

  .newsMobile {
    display: flex;
    flex-direction: column;

    .newsItem {
      padding: 0.8rem 0;
      text-align: center;
      font-family: Source Han Sans CN, Source Han Sans CN-6;

      .title {
        font-size: 0.4rem;
        font-weight: 500;
        color: #333333;
        line-height: 0.6rem;
        margin-bottom: 0.4rem;
      }

      .list {
        margin: 0 0.3rem;

        .listItem {
          background: #ffffff;
          border: 1px solid #eaeef0;
          box-shadow: 0px 20px 30px 0px rgba(183, 195, 214, 0.30);
          display: flex;
          margin-bottom: 0.24rem;

          .itemImg {
            width: 3.1rem;
            height: 1.74rem;
          }

          .con {
            font-size: 0.18rem;
            font-family: PingFang SC, PingFang SC-5;
            font-weight: 400;
            color: #666666;
            line-height: 0.28rem;
            width: 3.8rem;

            .con_title {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding: 0 0.16rem;
              font-size: 0.2rem;
              margin: 0.2rem 0 0.1rem;
              color:#333333;
            }

            .con_desc {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              margin: 0 0.16rem;
            }

            .tar {
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-top: 1px solid #DEE6EE;
              margin-top: 0.14rem;
              line-height: 0.25rem;
              padding: 0.07rem 0.18rem;

              .arrowRightIcon {
                width: 0.24rem;
                height: 0.24rem;
              }
            }
          }
        }
      }
    }

    .pb23{
      padding-left:0.23rem;
      padding-right: 0.23rem;
    }

    .pagination {
      margin-top: 20px;
      text-align: right;

      /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background: #FE7811;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/mobile/newsMobile.vue